import AlphaHelpers from '../abstracts/classes/alpha-helpers'
import merge from 'lodash-es/merge'

document.addEventListener('alpha.loaded', (e) => {
  const alphaModuleMgr = e.detail.emitter
  const modulesToInject = new Map()

  // add imageGallery to Gutenberg's gallery, image, media and text blocks
  modulesToInject.set('.wp-block-gallery:not(.no-lightbox), :not(.wp-block-gallery) > .wp-block-image:not(.no-lightbox), .wp-block-media-text:not(.no-lightbox)', {
    imageGallery: {}
  })

  // add bsAccordion to Bootstrap Blocks accordion & Rank Math FAQ
  modulesToInject.set('.accordion, #rank-math-faq .rank-math-list', {
    bsAccordion: {}
  })

  // add modal to Bootstrap Blocks modal
  modulesToInject.set('.modal.load-alpha-modal-module', {
    bsModal:{}
  })

  // add Swiper to image gallery
  modulesToInject.set('.wp-block-gallery.swiper-carousel, .swiper-carousel', {
    swiper: {}
  })

  // add Masonry to image gallery
  modulesToInject.set('.wp-block-gallery.masonry', {
    masonry: {}
  })

  for (const [selector, modules] of modulesToInject) {
    const elements = AlphaHelpers.smartQuerySelectorAll(selector)
    for (const el of elements) {
      let requiredModules = {}
      const attrName = AlphaHelpers.getAlphaAttributeName('required-modules')
      const attrValue = AlphaHelpers.getParsedJsonAttribute(el, attrName)
      if (attrValue) {
        requiredModules = attrValue
      }

      // merge required modules with existing ones and set new value
      requiredModules = merge(requiredModules, modules)
      el.setAttribute(attrName, JSON.stringify(requiredModules))
    }
  }

  alphaModuleMgr.dispatchModuleEvent('alpha', 'required-modules.injected')
})
